<template>
    <div>
        <van-field label="企业名称" placeholder="请输入企业名称" v-model="enterprise"></van-field>
        <van-field label="用户名" placeholder="请输入用户名" v-model="account"></van-field>
        <van-field label="密码" placeholder="请输入密码" type="password" v-model="password"></van-field>
        <van-button type="primary" size="large" @click="login">绑定</van-button>
    </div>
</template>

<script>
    import {Field, Button, Toast} from 'vant';
    import {parse} from "querystring";

    import wechatService from "../../service/wechatService";


    export default {
        data: function () {
            return {
                enterprise: '测试内容',
                account: '张敬轩',
                password: '000000'
            }
        },
        components: {
            [Field.name]: Field,
            [Button.name]: Button
        },
        methods: {
            login: async function () {
                let query = parse(window.location.href.split('?')[1].split('#')[0]);
                let code = query.code;
                let state = query.state;
                let resp = await wechatService.getOpenId(code, state);
                if (resp.data.Status === "1") {
                    await wechatService.bind(this.enterprise, this.account, this.password, resp.data.Data);
                    Toast.success('操作成功');
                }
            }
        }
    };
</script>
